<script>
import CedexDependenciesSelectTableCell from "./CedexDependenciesSelectTableCell.vue";

export default {
    name: "CopyDialog",
    components: {CedexDependenciesSelectTableCell},
    props: {
        isoCodeObject: Object,
        isoCodeArray: Array,
        isoCodeToSurveyTypeName: Object,
        locationCodeObject: Object,
        locationCodeArray: Array,
        locationCodePrefixToViewTypeName: Object
    },
    data() {
        return {
            isActive:     false,
            isoCode:      null,
            locationCode: null,
        }
    },
    mounted() {
        this.isActive = true;
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        change() {
            this.$emit('change', this.isoCode, this.locationCode);
        }
    },
    watch:{
        isActive: function(newValue)
        {
            if (!newValue){
                this.cancel();
            }
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="isActive"
        content-class="copy-dependency-line-popup"
        height="600"
        width="800"
    >
        <v-card>
            <v-card-title>
                {{$t('Select codes')}}
            </v-card-title>
            <v-card-text>
                <v-row align="top" justify="center">
                    <v-col cols="auto">
                        <v-card max-width="350">
                            <v-card-title>{{$t('ISO codes')}}</v-card-title>
                            <v-card-text>
                                <CedexDependenciesSelectTableCell
                                    type="isoCode"
                                    :value="isoCode"
                                    :allValuesObject="isoCodeObject"
                                    :allValuesArray="isoCodeArray"
                                    :codeTexts="true"
                                    :multiSelect="true"
                                    :rowSpan="1"
                                    :groupValuesMap="isoCodeToSurveyTypeName"
                                    @changeSelection="isoCode = $event.join(',')"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="auto">
                        <v-card max-width="350">
                            <v-card-title>{{$t('Location codes')}}</v-card-title>
                            <v-card-text>
                                <CedexDependenciesSelectTableCell
                                    type="locationCode"
                                    :value="locationCode"
                                    :allValuesObject="locationCodeObject"
                                    :allValuesArray="locationCodeArray"
                                    :codeTexts="true"
                                    :multiSelect="true"
                                    :rowSpan="1"
                                    :groupValuesMap="locationCodePrefixToViewTypeName"
                                    @changeSelection="locationCode = $event.join(',')"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="change">{{$t('Add line')}}</v-btn>
                <v-btn @click="cancel">{{$t('Cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>